import { resolve } from '../../../../../init/store';

export class Controller {

    /** @ngInject */
    constructor(Alert, SharedAccountsService,$state) {
        this.Alert = Alert;
        this.SharedAccountsService = SharedAccountsService;
        this.$state =$state;
    }

    $onInit() {
        this.corporateNote = {
			id:null,
            noteName: '',
            note: ''
        };
    }

    save() {
         this.isSaving = true;
        this.SharedAccountsService.createNote(
            {
                companyId: this.companyId,
            },
            this.corporateNote).$promise
            .then(note => {
                this.$state.go("^", {}, { reload: true });
                this.Alert('success', 'company.sharing-center.note.add.added');
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid;
    }

    
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/add/add-shared-note.controller.js